import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 14 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.55 11.805 4.455 14V.667C4.455.298 4.17 0 3.818 0s-.636.298-.636.667V14l-2.096-2.195a.615.615 0 0 0-.9 0 .69.69 0 0 0 0 .942l2.732 2.862c.249.26.574.39.9.39s.652-.13.9-.39l2.732-2.862a.69.69 0 0 0 0-.942.615.615 0 0 0-.9 0m7.263-7.61a.69.69 0 0 0 0-.942L11.081.39a1.24 1.24 0 0 0-.9-.391c-.325 0-.65.13-.899.39L6.55 3.252a.69.69 0 0 0 0 .943c.249.26.651.26.9 0l2.095-2.196v13.334c0 .369.285.667.637.667s.636-.298.636-.667V2l2.096 2.195c.248.261.65.261.9 0" }, null, -1)
  ]))]))
}
export default { render: render }